// Imports
import styled from 'styled-components/macro';
import LeadingText from '../../shared-components/leading-text';


// Styled components
const Container = styled.div`
	> div {
		margin-bottom: unset;
	}
`;


// Define the accepted props
interface Props {
	bodyText?: string;
}


// Function component
const GeneralText: React.FC<Props> = ({ bodyText }) => {
	// Return JSX
	return (
		<Container>
			<LeadingText>{bodyText ?? '<em>No text yet…</em>'}</LeadingText>
		</Container>
	);
};

export default GeneralText;
